// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"856":"c41002e8","935":"f6472154"}[chunkId] + ".js";
};